var map = {
	"./1.jpg": "7d36",
	"./11.jpg": "e092",
	"./12.jpg": "e343",
	"./13.jpg": "e63e",
	"./14.jpg": "a59e",
	"./16.jpg": "1e4f",
	"./forest.jpg": "f2c4",
	"./frcground.jpg": "9c30"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1791";